"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ftime = ftime;
const fdatetime_1 = require("./fdatetime");
/**
 * formatuje czas do formatu HH:mm:ss
 * @param dt data typu Date
 */
function ftime(dt) {
    return fdatetime_1.formatDateFunction['HH:mm:ss'](dt, null);
    // return padNumber(dt.getHours()) + ':' + padNumber(dt.getMinutes()) + ':' + padNumber(dt.getSeconds());
}
//# sourceMappingURL=ftime.js.map